<template>
  <div class="app">
    <yandex-map
      :coords="coords"
      zoom="11"
      style="
        height: 75vh;
        border: 2px solid #f2f9e9;
        border-radius: 5px;
        box-shadow: 1px 1px 10px rgba(0,0,0,0.4); 
      "
      :cluster-options="clusterOptions"
      :use-html-in-layout="true"
    >
      <ymap-marker
        v-for="billboard in samples"
        :marker-id="billboard.date"
        v-bind:key="billboard.date"
        marker-type="placemark"
        :balloon="{
          header: `${billboard.date}`,
          body: `<div style='padding-left: 16px';>
            <b>${getAddress(billboard.placeId)}</b>
            <div style='padding-block-end: 10px'>
            ${getPollutants(billboard.pollutants)}
            </div>
            <div style='padding-block-end: 10px'>
            ${getMeteoParam(billboard.meteoParam)}
            </div>
            </div>`,
          footer: '* для Смеси м-, п- ксилолов единицы измерения мг/м<sup>3</sup>'
        }"
        :coords="[billboard.loc.lat, billboard.loc.lng]"
        :cluster-name="billboard.placeId"
        :hint-content="getAddress(billboard.placeId)"
        :options="{ iconMaxWidth: 10, iconMaxHeight: 10 }"
      >
      </ymap-marker>
    </yandex-map>
  </div>
</template>

<script>
import { yandexMap, ymapMarker } from "vue-yandex-maps";
import axios from "axios";
import { bus } from "../main";

export default {
  components: { yandexMap, ymapMarker },
  data() {
    return {
      coords: [69.350073, 88.191778],
      samples: [],
      places: [],
      clusterOptions: [],
    };
  },
  methods: {
    getSamples: function (startDate, endDate) {
  axios
    .post("/getSamples", { startDate, endDate })
    .then((response) => {
      this.samples = (response.data || []).filter(
        (sample) => sample.placeId === 6 || sample.placeId === 9
      );
      if (this.samples.length === 0) {
        bus.$emit(
          "samples-is-empty",
          "Отборов в этот период не произведено"
        );
      } else {
        bus.$emit("samples-is-not-empty", "");
      }
    })
    .catch((e) => alert(e.toString()));
},
    getPlaces() {
      axios
        .get("/getPlaces")
        .then((response) => {
          this.places = response.data;
        })
        .catch((e) => alert(e.toString()));
    },
    getPollutants: function (pollutants) {
      let table = "";
      const styleOl = "border-left:4px solid #efefef;";
      const styleSpan =
        "float: right; display: inline-block; padding: 0 5px; font-size: 13px; ";
      const styleLi = " border-bottom: 3px solid #efefef; padding-top: 3px;";
      for (const key in pollutants) {
        let element = ""
        let color = "#999";
        if (pollutants.hasOwnProperty.call(pollutants, key)) {    
          if (key === "Смесь м-, п- ксилолов") {
            element = `${key}<span style="${styleSpan} color: ${color};"> ${pollutants[key]}*</span>`;
          } else {
            if (pollutants[key] >= 1) {
              color = "Red";
            }
            element = `${key}<span style="${styleSpan} color: ${color};"> ${pollutants[key]}</span>`;
          }
          table = table + `<li style="${styleLi}">${element}</li>`;
        }
      }
      return `<p style="margin-bottom: 3px;margin-top: 10px;">Концентрации загрязняющих веществ в долях ПДК<sub>мр</sub>:</p><ol style="${styleOl}";>${table}</ol>`;
    },
    getMeteoParam: function (meteoParam) {
      let table = "";
      const styleOl = "border-left:4px solid #efefef;";
      const styleSpan =
        "float: right; display: inline-block; padding: 0 5px; font-size: 13px; color: #999;";
      const styleLi = "border-bottom: 3px solid #efefef; padding-top: 3px;";
      for (const key in meteoParam) {
        if (meteoParam.hasOwnProperty.call(meteoParam, key)) {
          let element = `${key}<span style="${styleSpan}"> ${meteoParam[key]}</span>`;
          table = table + `<li style="${styleLi}">${element}</li>`;
        }
      }
      return `<p style="margin-bottom: 3px;">Метеопараметры:</p><ol style="${styleOl}";>${table}</ol>`;
    },
    getcord: function (billboard) {
      return `${billboard.loc.lat} ${billboard.loc.lng}`;
    },
    getAddress: function (placeId) {
      for (const key in this.places) {
        if (this.places.hasOwnProperty.call(this.places, key)) {
          if (this.places[key].id == placeId) {
            return this.places[key].address.String;
          }
        }
      }
    },
    getclusterOptions: function (places) {
      console.log(places + "получение кластеров");
      for (let index = 0; index <= places[places.length - 1].id; index++) {
        this.clusterOptions.push({
          gridSize:  places.radius,
          clusterDisableClickZoom: true,
          clusterOpenBalloonOnClick: true,
          clusterBalloonContentLayoutWidth: 500,
          clusterBalloonLeftColumnWidth: 154,
          clusterBalloonContentLayoutHeight: 300,
          preset: "islands#darkBlueClusterIcons",
          layout: `<div style ="padding-left: 0px";>
          <h1> {{properties.balloonContentHeader|raw}} </h1>
             {{ properties.balloonContentBody|raw }} 
             {{properties.balloonContentFooter|raw }}</div>                  
          `,
        });
      }
    },
  },
  mounted() {},
  created() {
    bus.$on("selected-date", (date) => {
      this.samples = [];
      this.getSamples(date.start, date.end);
    });
    this.getPlaces();
    this.$watch("places", (newVal) => {
      this.getclusterOptions(newVal);
    });
  },
};
</script>
<style scoped>
.app {
  position: relative;
  padding-right: 12px;
  padding-bottom: 12px;
  padding-left: 12px;
  padding-top: 5px;
}
ol {
  border-left: 4px solid #dfdfdf;
  padding-block-end: 10px;
}
</style>
